import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api/client';
import { keys } from '@/lib/queryKeys';
import type { SymptomField } from './symptomForm';

// Admin Panel → Clinical → Vitals Form Customization (backend routes/symptom-form.js).
// Hospital-wide, so tenant-keyed.

export type SymptomFieldInput = Partial<Pick<SymptomField,
  'label' | 'field_type' | 'options' | 'placeholder' | 'help_text' | 'max_length' | 'allow_custom' | 'mandatory' | 'enabled'>>;

export const getSymptomFields = (includeDisabled = false) =>
  api.get<SymptomField[]>(`/symptom-form${includeDisabled ? '?all=1' : ''}`);
export const createSymptomField = (data: SymptomFieldInput) => api.post<SymptomField>('/symptom-form', data);
export const updateSymptomField = (id: number, data: SymptomFieldInput) => api.patch<SymptomField>(`/symptom-form/${id}`, data);
export const deleteSymptomField = (id: number) => api.delete<{ deleted: true }>(`/symptom-form/${id}`);
export const reorderSymptomFields = (ids: number[]) => api.put<SymptomField[]>('/symptom-form/order', { ids });

/** The enabled fields, in order — what the Vitals stage renders. */
export function useSymptomFields() {
  return useQuery({
    queryKey: keys.config.symptomForm(false),
    queryFn: () => getSymptomFields(false),
    staleTime: 60 * 1000,
  });
}
